<template>
  <div class="container">
    <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
      <div class="mx-auto col-xl-8 col-lg-5 col-md-7">
        <div class="card z-index-0 mt-10">
          <div class="card-body">
            <soft-badge
              color="warning"
              variant="gradient"
              size="sm"
              @click="$emit('close-edit-form')"
              class="cursor-pointer float-right"
            >
              {{ $t("global.close") }}
            </soft-badge>
            <p class="my-3 text-bold">
              {{ $t("kids.kidUpdating") }}
            </p>

            <form @submit.prevent="submitForm">
              <div class="d-flex">
                <div class="col-xl-5 mx-5">
                  <div class="mb-3">
                    <InputForm
                      v-model="formData.kid_name"
                      :placeholder="localKid.kid_name"
                      type="text"
                    />
                  </div>
                  <div class="mb-3">
                    <DatePicker
                      v-model="formData.date"
                      :placeholder="localKid.birthday"
                      type="text"
                    />
                  </div>
                  <div class="mb-3">
                    <InputForm
                      v-model="formData.mobile"
                      :placeholder="
                        localKid.mobile
                          ? localKid.mobile
                          : $t('teachers.mobile')
                      "
                      type="text"
                    />
                  </div>
                  <div class="mb-3">
                    <SelectFormParent
                      v-model="parents"
                      @select="setParent"
                      :selectedOption="localKid.parent_object.parent_name"
                      type="text"
                    />
                  </div>
                  <div class="mb-3">
                    <div
                      v-for="(sub, index) in localKid.subcourse"
                      :key="sub.id"
                    >
                      {{ sub.title }}
                      <a
                        class="text-danger text-gradient mb-0 mx-3"
                        href="javascript:;"
                        @click="deleteSubcourse(sub.id)"
                      >
                        <i class="far fa-trash-alt me-1" aria-hidden="true"></i
                        >{{ $t("global.delete") }}</a
                      >
                      <span v-show="showForm">
                        <div class="d-flex my-3 input-group-text">
                          <input
                            :id="'input-' + sub.id"
                            v-model="newDiscount[index].discount"
                            type="text"
                            class="form-control"
                          />
                          <a
                            href="#"
                            class="mx-3 my-2"
                            @click="resetNewDiscount"
                          >
                            <i class="fas fa-undo" aria-hidden="true"></i>
                            {{ $t("global.cancel") }}
                          </a>
                        </div>
                      </span>
                      <p>
                        {{ $t("subcourses.discount") }}:
                        {{ formatPrice(localKid.subcourse[index].discount) }}
                        {{ $t("global.currency") }}
                        <a href="#" @click="showForm = !showForm" class="mx-3">
                          <i
                            class="fas fa-pencil-alt text-dark"
                            aria-hidden="true"
                          ></i>
                          {{ $t("global.edit") }}
                        </a>
                      </p>
                      <hr />
                    </div>
                  </div>
                </div>
                <div class="col-xl-5 mx-2">
                  <div class="mb-3">
                    <SelectFormCourse
                      @select="setSubcourse"
                      v-model="subcourses"
                      :isDisabled="false"
                      :selectedOption="$t('subcourses.addSubcourse')"
                    />
                  </div>
                  <div class="mb-3">
                    <InputForm
                      @select="getSubcourses"
                      v-model="formData.discount"
                      :placeholder="$t('subcourses.discount')"
                      :selectedOption="$t('courses.selectSubcourse')"
                      :isDisabled="!this.formData.subcourse.length"
                    />
                  </div>
                  <div class="align-text-center justify-content-center">
                    <div style="display: inline-block">
                      <img :src="localKid.image" class="right-img mb-2 mx-2" />
                    </div>
                    <label
                      style="display: inline-block"
                      for="file"
                      :v-model="formData.file"
                      class="mx-2 custom-file-upload"
                      ><span>{{ $t("global.uploadImage") }}</span>
                    </label>
                    <input
                      type="file"
                      id="file"
                      @change="handleFileUpload"
                      accept="image/*"
                    />
                  </div>
                </div>
              </div>
              <div class="text-center col-4 mx-auto">
                <soft-button
                  color="dark"
                  full-width
                  variant="gradient"
                  class="my-4 mb-2"
                >
                  {{ $t("global.edit") }}
                </soft-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InputForm from "@/components/InputForm.vue";
import SelectFormCourse from "@/components/SelectFormCourse.vue";
//import SelectFormSubcourse from "@/components/SelectFormSubcourse.vue";
import SoftButton from "@/components/SoftButton.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import DatePicker from "@/components/DatePicker.vue";
import swal from "sweetalert2";
import SelectFormParent from "./SelectFormParent.vue";

export default {
  name: "FormCreateTeacher",
  components: {
    InputForm,
    SelectFormCourse,
    SelectFormParent,
    SoftButton,
    SoftBadge,
    DatePicker,
  },
  props: {
    kid: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      formData: {
        id: this.kid.id,
        kid_name: "",
        mobile: "",
        discount: "",
        subcourse: [],
        newDiscount: [],
        date: "",
        parent_id: this.kid.parent_object.id,
      },
      parents: [],
      courses: [],
      subcourses: [],
      selectedFile: this.kid.image,
      selectedCourse: null,
      selectedSubcourse: null,
      isFirstSelected: false,
      showForm: false,
      imageUrl: "",
      localKid: { ...this.kid },
      image: this.kid.image,
      newDiscount: this.kid.subcourse,
      //subId: this.kid.subcourse ? this.kid.subcourse[0].id : null,
      subId: null,
    };
  },
  created() {
    this.getSubcourses();
    this.getParents();
  },
  watch: {
    kid(newKid) {
      this.localKid = { ...newKid };
    },
    handler() {
      this.getParents();
      this.getSubcourses();
    },
  },
  methods: {
    async submitForm(event) {
      event.preventDefault();
      const formData = new FormData();
      formData.append("_method", "PATCH");
      formData.append("id", this.formData.id);
      formData.append("subId", this.subId);
      formData.append("parentId", this.formData.parent_id);
      if (this.formData.kid_name != "") {
        formData.append("kid_name", this.formData.kid_name);
      }
      if (this.formData.discount != "") {
        formData.append("discount", this.formData.discount);
      }
      if (this.formData.mobile != "") {
        formData.append("mobile", this.formData.mobile);
      }
      if (this.formData.date != "") {
        formData.append("birthday", this.formData.date);
      }
      if (this.formData.subcourse != "") {
        formData.append("subcourse", this.formData.subcourse);
      }
      if (this.selectedFile != "") {
        formData.append("image", this.selectedFile);
      } else {
        formData.append("image", this.image);
      }
      if (this.newDiscount != "") {
        let newSubcourseIds = [];
        let newDiscounts = [];
        this.newDiscount.forEach((item) => {
          newSubcourseIds.push(item.id);
          newDiscounts.push(item.discount);
        });
        formData.append("newSubcourseIds", newSubcourseIds);
        formData.append("newDiscounts", newDiscounts);
      }
      try {
        const response = await axios.post("kid/" + this.localKid.id, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.status == 200) {
          this.resetForm();
          swal.fire({
            icon: "success",
            title: this.$t("kids.kidUpdated"),
            showConfirmButton: false,
            timer: 2000,
          });
          this.localKid = response.data.kid;
          this.$emit("close-edit-form", this.localKid);
        }
      } catch (error) {
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors;
          let errorMessages = "";

          if (typeof errors === "function") {
            for (const key in errors) {
              if (errors.prototype.hasOwnProperty.call(errors, key)) {
                errorMessages += `- ${errors[key].join(", ")}\n`;
                swal.fire({
                  title: this.$t("global.error"),
                  html: errorMessages.replace(/\n/g, "<br>"),
                  icon: "error",
                  position: "top-end",
                });
              }
            }
          } else {
            for (const key in errors) {
              errorMessages += `- ${errors[key].join(", ")}\n`;
              swal.fire({
                title: this.$t("global.error"),
                html: errorMessages.replace(/\n/g, "<br>"),
                icon: "error",
                position: "top-end",
              });
            }
          }
        }
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      this.selectedFile = file;
      this.imageUrl = URL.createObjectURL(file);
    },
    async getSubcourses() {
      const response = await axios.get("subcourses/all");
      this.subcourses = response.data.subcourses.filter(
        (subcourse) =>
          !this.kid.subcourse.some(
            (kidSubcourse) => kidSubcourse.id === subcourse.id
          )
      );
    },
    setSubcourse(selectedSubcource) {
      this.formData.subcourse = selectedSubcource;
    },
    async deleteSubcourse(subcourseId) {
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        text: "",
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(
            "delete-kid-subcourse/" + this.kid.id + "/" + subcourseId
          );
          this.localKid = response.data.kid;
          swal.fire({
            icon: "success",
            title: response.data.message,
            showConfirmButton: true,
            width: "64em",
          });
        } catch (error) {
          if (error.response && error.response.status === 422) {
            const errors = error.response.data.errors;
            let errorMessages = "";

            if (typeof errors === "function") {
              for (const key in errors) {
                if (errors.prototype.hasOwnProperty.call(errors, key)) {
                  errorMessages += `- ${errors[key].join(", ")}\n`;
                  swal.fire({
                    title: this.$t("global.error"),
                    html: errorMessages.replace(/\n/g, "<br>"),
                    icon: "error",
                    position: "top-end",
                  });
                }
              }
            } else {
              for (const key in errors) {
                errorMessages += `- ${errors[key].join(", ")}\n`;
                swal.fire({
                  title: this.$t("global.error"),
                  html: errorMessages.replace(/\n/g, "<br>"),
                  icon: "error",
                  position: "top-end",
                });
              }
            }
          }
        }
      } else {
        swal.fire({
          title: "Brisanje otkazano!",
          text: "",
          icon: "success",
        });
      }
    },
    handleFirstSelectChange(selectedValue) {
      this.isFirstSelected = !!selectedValue; // Proverava da li je vrednost izabrana
    },
    resetNewDiscount() {
      this.formData.newDiscount = this.localKid.subcourse[0].discount;
      this.showForm = false;
    },
    formatPrice(value) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2, // Obavezna dva decimalna mesta
        maximumFractionDigits: 2, // Maksimalna dva decimalna mesta
      }).format(value);
    },
    setParent(parent_id) {
      this.formData.parent_id = parent_id;
    },
    async getParents() {
      const response = await axios.get("parents/all");
      this.parents = response.data.parents.filter(
        (parent) => parent.id !== this.kid.parent
      );
    },
    resetForm() {
      this.formData.kid_name = "";
      this.formData.mobile = "";
      this.formData.subcourse = null;
      this.formData.date = "";
      this.selectedFile = null;

      return;
    },
  },
};
</script>

<style scoped>
.custom-file-upload {
  display: inline-block;
  padding: 10px 20px;
  cursor: pointer;
  background: linear-gradient(to right, #7fe02f, #2cb735);
  color: white;
  border-radius: 8px;
}

#file {
  display: none;
}

.custom-file-upload span {
  pointer-events: none;
}

.float-right {
  float: right;
}

.right-img {
  position: relative;
  border: 1px solid gray;
  padding: 6px;
  border-radius: 8px;
  width: 125px !important;
  height: 125px !important;
}
</style>
